import noop from 'lodash/noop';
import styled from 'styled-components';

import { WORKFLOW_ACTIONS } from 'modules/workflows/constants';

import { isModifyMessageTypeAction } from '../ModifySubscriptionEditor.utils';
import MultiSubscriptionSelect from './MultiSubscriptionSelect';
import RadioRow from './RadioRow';
import { propertyNames } from './SubscriptionPicker.constants';
import { SubscriptionPickerProps } from './SubscriptionPicker.types';
import { getMultiselectSelections } from './SubscriptionPicker.utils';
import { useMultiSubscriptionData } from './useMultiSubscriptionData';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const { MODIFY_CHANNEL_SUBSCRIPTION, MODIFY_MESSAGE_TYPE } = WORKFLOW_ACTIONS;

export const MULTI_SUBSCRIPTION_PICKER_TEST_ID = 'multi-subscription-picker';

const MultiSubscriptionPicker = ({
  isDisabled,
  nodeData,
  hasError,
  onSelect = noop,
}: Omit<SubscriptionPickerProps, 'placeholder'>) => {
  const selections = getMultiselectSelections(nodeData);

  const { channelOptions, messageCategories, messageOptions } = useMultiSubscriptionData();

  const handleRadioSelect = (value: string) => onSelect({ nodeClass: value });

  const handleSubscriptionSelect = (selectionType: string, selectedVals: number[]) => {
    const { plural, singular } = propertyNames[selectionType];
    onSelect({ [plural]: selectedVals, [singular]: null });
  };

  return (
    <Wrapper data-test={MULTI_SUBSCRIPTION_PICKER_TEST_ID}>
      <RadioRow
        isChecked={!isModifyMessageTypeAction(nodeData.nodeClass)}
        isDisabled={isDisabled}
        label="Channels"
        onSelect={handleRadioSelect}
        value={MODIFY_CHANNEL_SUBSCRIPTION}
      >
        <MultiSubscriptionSelect
          defaultValues={selections.channelTypes}
          filterPlaceholder={'Search all channels'}
          isDisabled={isDisabled}
          isError={hasError}
          nodeClass={MODIFY_CHANNEL_SUBSCRIPTION}
          onSelect={(s) => handleSubscriptionSelect(MODIFY_CHANNEL_SUBSCRIPTION, s)}
          options={channelOptions}
          placeholder="Select channels..."
        />
      </RadioRow>
      <RadioRow
        isChecked={isModifyMessageTypeAction(nodeData.nodeClass)}
        isDisabled={isDisabled}
        label="Message Types"
        onSelect={handleRadioSelect}
        value={MODIFY_MESSAGE_TYPE}
      >
        <MultiSubscriptionSelect
          categoryLabels={messageCategories}
          defaultValues={selections.messageTypes}
          filterPlaceholder={'Search all types'}
          isDisabled={isDisabled}
          isError={hasError}
          nodeClass={MODIFY_MESSAGE_TYPE}
          onSelect={(s) => handleSubscriptionSelect(MODIFY_MESSAGE_TYPE, s)}
          options={messageOptions}
          placeholder="Select types..."
        />
      </RadioRow>
    </Wrapper>
  );
};

export default MultiSubscriptionPicker;
